import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { Suspense, lazy } from "react";

const BaseLineAssessments = lazy(() => import("./AssessmentQuestions"));
const BaseLineAssessmentsLazy = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BaseLineAssessments />
    </Suspense>
  );
};

export default BaseLineAssessmentsLazy;
